/**
 * This is a very important function to determine which route the websocket takes
 * If it is deprecated, it will be dropped
 *
 * New Live Sesssion message will have param `_from` = `live`
 * in order to proceed
 * @param {*} doc
 * @returns
 */
export const isDeprecatedWSMessage = (doc) => {
  try {
    if (doc.type === 'presentation' && doc.action === 'nextSlide' && doc._from != 'live') {
      return true
    }
    if (doc.type === 'quiz-audience' && doc.action === 'startCountdownPickAnswer' && doc._from != 'live') {
      return true
    }
    return false
  } catch (e) {
    return false
  }
}
